import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import CustomerForm, { addressDescription } from "./customerForm";
import CustomersActions from "../customersActions";
import CustomersStore from "../customersStore";
import { ClienteData } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";
import { Link } from "../../common/components/link";
import { ResponsiveToolbar } from "../../common/components/ResponsiveToolbar";
import { messageAlert } from "../../common/components/confirm";
import { getGeoLocation } from "../../common/components/googleMap";

export const SaveOrUpdateCustomer = async (data: ClienteData, id?: number) => {
    if (!data.latitudine && !data.longitudine) {
        const result = await getGeoLocation({ address: addressDescription(data) })
        data.latitudine = result?.lat;
        data.longitudine = result?.lng;
    }

    if (id) {
        if (await CustomersActions.codiceClienteAziendaExist(data.codiceClienteAzienda, id)) {
            messageAlert(<h3><i className="fa fa-exclamation-circle text-danger" /> Il codice cliente {data.codiceClienteAzienda} esiste già</h3>)
            return;
        }
        const result = await CustomersActions.update(data, +id);
        return result;
    }
    else {
        if (!data.codiceClienteAzienda) {
            data.codiceClienteAzienda = await CustomersActions.getAvailableCodiceClienteAzienda();
        }
        else if (await CustomersActions.codiceClienteAziendaExist(data.codiceClienteAzienda, null)) {
            messageAlert(<h3><i className="fa fa-exclamation-circle text-danger" /> Il codice cliente {data.codiceClienteAzienda} esiste già</h3>)
            return;
        }
        const result = await CustomersActions.add(data);
        return result;
    }
}
interface Props extends RouteComponentProps<{ id?: string }> {
}
export default (props: Props) => {
    let { history, match: { params: { id } } } = props;
    let customer = CustomersStore.use(id ? +id : null);

    const [codiceCliente, setCodiceCliente] = React.useState<number | null>(null);
    useEffect(() => {
        async function fetch() {
            if (!id) {
                setCodiceCliente(await CustomersActions.getAvailableCodiceClienteAzienda());
            }
        }
        fetch();
    }, [id])

    if (!codiceCliente && !id)
        return <Loading />
    if (id && !customer)
        return <Loading />;


    const save = async (customer: ClienteData) => {
        if (id) {
            const c = await SaveOrUpdateCustomer(customer, +id);
            if (c) history.goBack();
        }
        else {
            const c = await SaveOrUpdateCustomer(customer);
            if (c) history.push(links.customerShow(c!.idCliente))
        }
    }


    let dto = new ClienteData();
    if (id) {
        dto.init({
            ...customer,
            comune: customer?.comune,
            frazione: customer?.frazione,
        } as ClienteData);
    }
    else {
        dto.codiceClienteAzienda = codiceCliente!;
    }

    return (
        <div className="card">
            <div className="card-header bg-theme d-flex align-items-center">
                <div className="flex-fill">
                    <h3 className="text-white mb-0 text-truncate">Cliente {customer?.nomeProprietario} {customer?.cognomeProprietario}</h3>
                </div>
                {
                    id != null && <>
                        <ResponsiveToolbar>
                            <Link
                                className="btn btn-outline-secondary"
                                to={links.interventoNew({ idCliente: +id! })}>
                                <i className="fas fa-truck" /> +Intervento
                            </Link>
                            <Link
                                className="btn btn-outline-secondary"
                                to={links.impiantoSelection(+id)}>
                                <i className="fas fa-truck" /> +Impianto
                            </Link>
                        </ResponsiveToolbar>
                    </>
                }
            </div>
            <div className="card-body pb-0">
                <div className="mt-1">
                    <CustomerForm
                        customer={dto}
                        onSubmit={save}
                        onCancel={() => history.goBack()}
                        idCliente={id ? parseInt(id) : null}
                    />
                </div>
            </div>
        </div >
    );
}